import gql from 'graphql-tag';

const topThreeData = gql`
  fragment topThreeData on ProductTilesResult {
    ruleNumber
    productTiles {
      tile
      sequenceNumber
      productData {
        recommendationData {
          rank
        }
        price {
          value
        }
        priceRange {
          minPrice {
            value
          }
          maxPrice {
            value
          }
        }
        brand
        images {
          altText
          format
          imageType
          url
        }
        line
        manufacturer
        unitName
        url
        mapDisplayRule {
          messageDisplay
          mapPriceDisplay
          message
        }
        mapPrice {
          value
        }
        mapRuleSatisfied
        rearProduct {
          price {
            value
          }
          priceRange {
            minPrice {
              value
            }
            maxPrice {
              value
            }
          }
          code
          mapDisplayRule {
            messageDisplay
            mapPriceDisplay
            message
          }
          mapPrice {
            value
          }
          mapRuleSatisfied
        }
        name
        code
      }
    }
  }
`;

export const STANDARD_TOP_THREE = gql`
  query getStandardTiles(
    $vehicleInfo: VehicleInput!
    $searchInput: StandardTilesInput!
    $storeCode: String!
  ) {
    fitmentSearch(vehicleInfo: $vehicleInfo) {
      standardTiles(searchInput: $searchInput, storeCode: $storeCode) {
        ...topThreeData
      }
    }
  }

  ${topThreeData}
`;

export const STAGGERED_TOP_THREE = gql`
  query getStaggeredTiles(
    $vehicleInfo: VehicleInput!
    $searchInput: StaggeredTilesInput!
    $storeCode: String!
  ) {
    fitmentSearch(vehicleInfo: $vehicleInfo) {
      staggeredTiles(searchInput: $searchInput, storeCode: $storeCode) {
        ...topThreeData
      }
    }
  }

  ${topThreeData}
`;
